Alpine.data('QuickFact', () => ({
  hasRowSiblings: false,
  checkRow() {
    /*
     * Check if any other quick facts are in the same row
     * (i.e. have a top position within 5px of this one).
     * Used to add class to reduce top margin when eyebrows are present.
     */
    const myTop = this.$el.getBoundingClientRect().top;
    this.hasRowSiblings = [...document.querySelectorAll('.quick-fact')]
      .some(s => s !== this.$el
        && Math.abs(s.getBoundingClientRect().top - myTop) < 5
        && s.querySelector('.eyebrow'));
  },
  init() {
    this.$nextTick(() => this.checkRow());
    this._ro = new ResizeObserver(() => this.checkRow());
    this._ro.observe(this.$el);
  },
  destroy() {
    this._ro.disconnect();
  }
}));
